package com.sweetlime.dungeonamigo.presentation.ui.theme

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import dungeonamigo.shared.generated.resources.Res
import dungeonamigo.shared.generated.resources.pixelify_sans_bold
import dungeonamigo.shared.generated.resources.pixelify_sans_regular
import dungeonamigo.shared.generated.resources.silkscreen_bold
import dungeonamigo.shared.generated.resources.silkscreen_regular
import org.jetbrains.compose.resources.Font

/** Pixelify Sans — titles, character names, all numbers (HP, level, AC, stats, dice). */
@Composable
fun pixelFont(): FontFamily = FontFamily(
    Font(Res.font.pixelify_sans_regular, FontWeight.Normal),
    Font(Res.font.pixelify_sans_bold, FontWeight.Bold),
)

/** Silkscreen — tiny uppercase labels (HP, AC, ROOM CODE, section micro-labels). */
@Composable
fun silkFont(): FontFamily = FontFamily(
    Font(Res.font.silkscreen_regular, FontWeight.Normal),
    Font(Res.font.silkscreen_bold, FontWeight.Bold),
)
